var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.prop)?_c('Preloader'):_c('div',[_c('DetailCarousel',{attrs:{"items":_vm.prop.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }